import Container from '../Container';

import { SpinnerWrapper, Spinner } from './styles';

const Loader = () => {
  return (
    <Container>
      <SpinnerWrapper data-testid="loader-component">
        <Spinner />
      </SpinnerWrapper>
    </Container>
  );
};

export default Loader;
